/**
 * functions
 */
import { updateLazy } from '../functions/lazy';
import { initTippy } from '../functions/tippy';
import smoothscroll from 'smoothscroll-polyfill';

/**
 * common & components
 */
import '../common/eshop';
import '../common/window';
import '../common/info-messages';
import '../common/toggle-password';

import '../common/product-cart-quantity';
import '../common/spinner-quick-update';

import '../components/modal/modal-back';
import '../components/modal/modal-jump';

import '../components/header';
import '../components/footer';

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.addedItem', { form, response })
}
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.rEvent.dispatch('Custom.Cart.updatedItem', { input, response })
}
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.removedItem', { form, response })
}

window.updateLazy = updateLazy();

document.addEventListener('DOMContentLoaded', () => {
    updateLazy();
    initTippy()
});

function checkIcdph() {
    if (document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').checked) {
        document.querySelector('.js-sk-vat .c-form__input').setAttribute('required', 'required');
        document.querySelector('.js-sk-vat').classList.add('is-required');
    } else {
        document.querySelector('.js-sk-vat .c-form__input').removeAttribute('required');
        document.querySelector('.js-sk-vat').classList.remove('is-required');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-back').forEach(back => {
        back.addEventListener('click', event => {
            if (event.currentTarget.getAttribute('href') == '#') {
                window.history.back()
            }
        })
    })

    if (document.querySelector('.js-toggle-icdph')) {
        checkIcdph();

        document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').addEventListener('change', event => {
            checkIcdph();
        });
    }
})

smoothscroll.polyfill();
